var map = {
	"./interview-hero-img-2.webp": 3752,
	"./interview-laptop-any-job.webp": 3757,
	"./interview-laptop-compiler.webp": 3758,
	"./interview-laptop-hr.webp": 3755,
	"./interview-laptop-result-cut.webp": 3759,
	"./interview-laptop-result.webp": 3890,
	"./interview-laptop-technical.webp": 3756,
	"./interview-laptop-web.webp": 3891,
	"./interview-laptop.webp": 3525,
	"./interview-techs-2.webp": 3892,
	"./techs-icons/ds-is-icon-python-scroll.webp": 3760,
	"./techs-icons/ds-is-icon-r-scroll.webp": 3761,
	"./techs-icons/ds-is-icon-sql-scroll.webp": 3762,
	"./techs-icons/python-hero.webp": 3753,
	"./techs-icons/python-talk-is-cheap.webp": 3893,
	"./techs-icons/r-hero.webp": 3754,
	"./techs-icons/r-talk-is-cheap.webp": 3894,
	"./techs-icons/slqlite-talk-is-cheap.webp": 3895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5256;